export enum Profiles {
  ADMIN = 'e467fd81-bc61-4d1f-8cee-a4519aa1b683',
  ANALIST = '830e2149-9571-42b4-8e16-73cd18bbedab',
  PROVIDER = '991b4a34-c929-498c-aa0a-e5c7542210f3',
  CUSTOMER = '36abae5c-8bc2-4c41-8ad0-baadc92dbaa4',
}
